export const Routes = {
  LOGIN: "/",
  SIGN_UP: "/SignUpPage",
  PASSWORD_SEND: "/PasswordSend",
  PASSWORD_RESET: "/PasswordReset",
  MACHINE_LIST: "/MachineList",
  MACHINE_REGISTER: "/MachineList/Register",
  MACHINE_MODIFY: "/MachineList/machineModify/:id",
  COLLECTION_DATA_SET: "/MachineList/CollectionDataSet/:id",
  USER_PROFILE: "/UserProfile",
  USER_PROFILE_MODIFY: "/UserProfile/Modify",
  USER_MANAGEMENT: "/UserManagement",
  DASHBOARD: "/MachineList/Dashboard",
  TREND_EXPAND: "/MachineList/Dashboard/TrendExpand",
  LISENCE: "/credits",
  ERROR: "/ErrorScreen",
};
